module.exports = __webpack_public_path__ + "img/205.tables.05fef91a.svg";